import whoIsTheBuddha from './buddha/who-is-the-buddha.json';
import whereDidTheBuddhaGo from './buddha/where-did-the-buddha-go.json';
import rgyalBuKhrungsPa from './buddha/rgyal-bu-khrungs-pa.json';
import phoBrangNang from './buddha/pho-brang-nang.json';
import rgyalBuSemsKhral from './buddha/rgyal-bu-sems-khral.json';
import theTigressJataka from './buddha/the-tigress-jataka.json';
import theDiamondSutra from './buddha/the-diamond-sutra.json';
import tenzinIsNotHappy from './tenzin/tenzin-is-not-happy.json';
import whereDidTheParrotGo from './tenzin/where-did-the-parrot-go.json';
import drolmaWantsToSleep from './tenzin/drolma-wants-to-sleep.json';
import norbuIsAfraid from './tenzin/norbu-is-afraid.json';
import tenzinWantsToPlay from './tenzin/tenzin-wants-to-play.json';
import tenzinSeesAMonkey from './tenzin/tenzin-sees-a-monkey.json';
import dekyisRing from './tenzin/dekyis-ring.json';

const stories = [
  whoIsTheBuddha,
  whereDidTheBuddhaGo,
  rgyalBuKhrungsPa,
  phoBrangNang,
  rgyalBuSemsKhral,
  theTigressJataka,
  theDiamondSutra,
  tenzinIsNotHappy,
  whereDidTheParrotGo,
  drolmaWantsToSleep,
  norbuIsAfraid,
  tenzinWantsToPlay,
  tenzinSeesAMonkey,
  dekyisRing,
];

export default stories;
